/** Scroll back to the hero and put the cursor in "What do you want to learn?" (if the intake hasn't started). */
export function goToHero() {
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.getElementById("top")?.scrollIntoView({ behavior: reduced ? "auto" : "smooth" });
  setTimeout(() => document.getElementById("learn-input")?.focus({ preventScroll: true }), reduced ? 0 : 600);
}
